import React, { useState } from "react";
import { Box, Typography, styled } from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { Text, Title } from "./style";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";

const RootStyle = styled(Box)(({ theme }) => ({
  background: "#F4F4F4",
  padding: "72px 83px",
  [theme.breakpoints.down("md")]: {
    padding: "30px 15px",
  },
}));

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));
const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "1.5rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  //   flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: "32px",
  background: "#FBF8DB",
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));
const SubTitle = styled(Typography)(({ theme }) => ({
  fontSize: "24px",
  fontFamily: "Poppins",
  fontWeight: 600,
  color: "#60656C",
  [theme.breakpoints.down("md")]: {
    fontSize: "20px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
  },
}));

function FAQs() {
  const [expanded, setExpanded] = useState(1);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <RootStyle>
      <Title sx={{ mb: { xs: "30px", md: "73px" }, textAlign: "center" }}>
        Frequently Asked Questions
      </Title>

      <Accordion expanded={expanded === 1} onChange={handleChange(1)}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <SubTitle>Which is the best software for billing ?</SubTitle>
        </AccordionSummary>
        <AccordionDetails>
          <Text>
            ManageKaro app is the best billing software available for businesses
            in Pakistan. The ManageKaro app and Web App provides access to a
            range of useful features. They can make the business management
            process seamless for business owners. Using our billing tool, you
            can save a lot of time and effort required in creating GST invoices
            and bills. You can use automation tools, managing inventory using
            tracking features. Further, you can create reports using stored
            data, and much more.
          </Text>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 2} onChange={handleChange(2)}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <SubTitle>What type of software is the billing system?</SubTitle>
        </AccordionSummary>
        <AccordionDetails>
          <Text>
            In general, billing software helps generate and send GST bills. It
            allows you to track the products and services your customers use.
            Further it allows you to receive payments. However, some billing
            platforms like ManageKaro are capable of much more. Using
            ManageKaro, you can automate the repetitive tasks of your business.
            You can manage accounts, and create business reports too.
          </Text>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 3} onChange={handleChange(3)}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <SubTitle>How do I get a computerised GST bill?</SubTitle>
        </AccordionSummary>
        <AccordionDetails>
          <Text>
            You can use ManageKaro bills to create computerised GST bills for
            your customers. The invoicing tools and billing software by
            ManageKaro make the entire process seamless. It does not make a dent
            in your financials, as free templates does not require you to pay.
          </Text>
          <Text>
            You can use the ManageKaro software, automate your business’s
            billing process. It will save your employees time by creating
            computerised bills.
          </Text>
        </AccordionDetails>
      </Accordion>
    </RootStyle>
  );
}

export default FAQs;
